import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApModalResult, ApModalService } from '../modals/index';
import { ApFileUploadModalComponent } from './ap-file-upload-modal.component';

@Injectable({
  providedIn: 'root',
})
export class ApFileUploadModalService {
  constructor(
    private apModalService: ApModalService,
  ) {
  }

  openModal(
    title = '',
    message = '',
    allowedExtensions = '',
  ): Observable<ApModalResult<File>> {
    const initialState = {
      allowedExtensions,
      message,
      title,
    };
    const obs = this.apModalService.showComponentModal$(ApFileUploadModalComponent, {
      initialState,
    });
    return obs;
  }
}
